export default {
  "Autocomplete.all_number_selected": "所有 {number} 已选择",
  "Autocomplete.all_number": "全部（{number}）",
  "Card.toggle_content": "切换内容",
  "Chip.remove": "消除",
  "DatePicker.next": "下一个",
  "DatePicker.previous": "以前的",
  "Pagination.first": "第一的",
  "Pagination.go_to_page_number": "转到第 {index} 页",
  "Pagination.go_to_page": "转到 {label} 页面",
  "Pagination.last": "最后的",
  "Pagination.next": "下一个",
  "Pagination.previous": "以前的",
  "Table.actions": "表操作",
  "Table.add_column": "添加列",
  "Table.clear_selection": "清除选择",
  "Table.filter": "筛选",
  "Table.hide": "隐藏",
  "Table.more_actions": "更多操作",
  "Table.move_left": "向左移动",
  "Table.move_right": "向右移",
  "Table.pagination": "表格分页",
  "Table.pagination_loading": "正在加载表格分页控件",
  "Table.per_page": "每页",
  "Table.position_zero": "0 {total}",
  "Table.position": "{start}-{end} 共 {total}",
  "Table.search": "搜索",
  "Table.select_all": "全选",
  "Table.select_all_n": "选择全部 {count}",
  "Table.select_row": "选择{row}",
  "Table.sort_ascending": "升序",
  "Table.sort_descending": "降序排列",
  "TextInput.clear_labelled_input": "清除{label}",
  "Ui.clear_all": "全部清除",
  "Ui.close": "关闭",
  "Ui.loading": "加载中",
  "Ui.no_results": "没有结果",
  "Ui.number_selected": "已选择 {number}",
  "Ui.remove": "消除",
  "Ui.select_all": "全选",
  "Ui.show_more": "+ {count} 更多"
}
